export const ReportObjectTypes = {
  REPORTS_CE: 2,
  REPORTS_CRM: 0,
  REPORTS_INTERNAL: 1,
};
